import React from "react";
import { ArrowUpRight } from "lucide-react";
import { RevealText } from "./RevealText";

const items = [
  {
    n: "01",
    title: "Tailored Web Solutions",
    desc: "Every line of code shaped around your specific business goals — never templated.",
  },
  {
    n: "02",
    title: "AI-Driven Efficiency",
    desc: "We embed intelligent automation that frees your team from repetitive busywork.",
  },
  {
    n: "03",
    title: "Agile Development Process",
    desc: "Weekly demos, transparent boards, and clear milestones from kickoff to launch.",
  },
  {
    n: "04",
    title: "Reliable Maintenance",
    desc: "Long-term partnership with monitoring, security patches, and continuous optimisation.",
  },
];

export const ValueProp = () => {
  return (
    <section
      id="process"
      data-testid="value-section"
      className="relative value-bg overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-24 sm:py-32">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-xs uppercase tracking-[0.22em] text-white/60 mb-4">
            Our Promise
          </p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white">
            <RevealText>Built on Trust.</RevealText>
            <br />
            <RevealText delay={240} className="text-white/85">
              Driven by Results.
            </RevealText>
          </h2>
          <p className="mt-6 text-white/75 leading-relaxed">
            We don&apos;t just deliver projects — we partner with you to engineer
            measurable, lasting outcomes for your business.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it, i) => (
            <div
              key={it.n}
              data-testid={`value-card-${i}`}
              className="value-box rounded-2xl p-6 relative group"
            >
              <div className="flex items-start justify-between mb-10">
                <span className="font-mono-ui text-3xl font-bold text-white">
                  {it.n}
                </span>
                <div className="w-8 h-8 rounded-full border border-white/30 flex items-center justify-center text-white/70 group-hover:border-white group-hover:text-white transition">
                  <ArrowUpRight size={14} />
                </div>
              </div>
              <h3 className="font-display text-lg font-semibold text-white mb-2 leading-tight">
                {it.title}
              </h3>
              <p className="text-sm text-white/75 leading-relaxed">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
